import basketApiClient from '../basket/apiClient';
import currenciesService from '../currenciesService';
import events from '../events';
import formatPrice from '../utils/formatPrice';
import './shoppingCart.scss';
const initState = {
    error: '',
    success: null,
};
export function shoppingCartData() {
    return {
        ...initState,
        loading: true,
        basket: null,
        itemsLoading: {},
        items: [],
        errorMessage: '',
        isLoading: false,
        init() {
            events.onCurrencyChanged.subscribe(currency => {
                this.applyCurrencyExchange(currency);
            });
            this.loading = true;
            basketApiClient.get()
                .then(data => {
                this.basket = data;
                this.items = data.products;
                this.loading = false;
            })
                .catch(err => this.error = err)
                .finally(() => {
                this.applyCurrencyExchange(currenciesService.getRate());
            });
        },
        goBack() {
            window.history.back();
        },
        async checkProductsStockAndGoTo(href) {
            this.isLoading = true;
            try {
                await basketApiClient.isCorrectStatus();
                this.errorMessage = ``;
                location.href = href;
            }
            catch (error) {
                this.errorMessage = error.status === 409 ? error.data.message : "En feil oppstod";
                this.isLoading = false;
            }
        },
        update(newQuantity, product) {
            product.quantity = newQuantity;
            this.itemsLoading[product.orderLineId] = true;
            basketApiClient.updateItem(product.orderLineId, newQuantity)
                .then(basket => {
                this.basket = basket;
                this.items = basket.products;
                events.onBasketUpdated.trigger({ basket, products: [] });
            })
                .catch(err => this.error = err)
                .finally(() => {
                this.applyCurrencyExchange(currenciesService.getRate());
                this.itemsLoading[product.orderLineId] = false;
            });
        },
        emptyBasket() {
            this.loading = true;
            basketApiClient.empty()
                .then(basket => {
                this.basket = basket;
                this.items = basket.products;
                events.onBasketUpdated.trigger({ basket, products: [] });
            })
                .catch(err => this.error = err)
                .finally(() => this.loading = false);
        },
        openLogin() {
            events.openLogin.trigger({ open: true, centeredFixed: true });
        },
        applyCurrencyExchange(currency) {
            if (!currency)
                return;
            if (currency.rate !== 1) {
                this.items.forEach(product => {
                    var _a, _b, _c, _d;
                    const foreignPrice = ((_b = (_a = product.discount) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : product.price) * currency.rate;
                    const foreignTotalPrice = ((_d = (_c = product.discount) === null || _c === void 0 ? void 0 : _c.totalPrice) !== null && _d !== void 0 ? _d : product.total) * currency.rate;
                    product.foreignPriceText = `~ ${formatPrice(foreignPrice, currency.currency)}`;
                    product.foreignTotalPriceText = `~ ${formatPrice(foreignTotalPrice, currency.currency)}`;
                });
                const foreignSubtotalPrice = this.basket.subtotal * currency.rate;
                this.basket.foreignSubtotalText = `~ ${formatPrice(foreignSubtotalPrice, currency.currency)}`;
            }
            else {
                this.items.forEach(product => {
                    product.foreignPriceText = '';
                    product.foreignTotalPriceText = '';
                });
                this.basket.foreignSubtotalText = '';
            }
        },
        formatPrice(price) {
            return formatPrice(price, "NOK");
        },
    };
}
